export default class Param {
    constructor(){

      this.root = "/";
        // this.root = "/test/";

        this.breakpoint = 750;
        this.displayType = ( window.innerWidth>this.breakpoint)?"pc":"sp";
        if(document.querySelector("html").classList.contains('ie') || document.querySelector("html").classList.contains('edge')){
            this.browserType = 'ie';
        }else if(document.querySelector("html").classList.contains('safari') && document.querySelector("html").classList.contains('pc')){
            this.browserType = 'safari';
        }else{
            this.browserType = 'other';
        }

        this.webgl = {
            top : {
                mainvisual : {
                    sence : [
                        {
                            illust : "./assets/video/top/movie01-illust.mp4",
                            bg : "./assets/video/top/movie01-bg.mp4",
                            body : "./assets/video/top/body-bg01_w.mp4",
                        }
                    ]
                }
            }
        }
        this.status = {

        }
        this.instagram = {
            src : "https://www.eventstudio.jp/getInstagram.php"
        }

    }
}
